import { useCallback, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AUTHORISED_CONTACTS_PER_PAGE, fetchAuthorisedContacts } from '../services/authorisedContacts';
import { agreementKeys } from './agreementKeys';

/** Page state is keyed by agreement id, so opening another agreement starts on page 1. */
export function useAuthorisedContacts(id: string | undefined) {
    const [pageState, setPageState] = useState({ id, page: 1 });
    const page = pageState.id === id ? pageState.page : 1;
    const setPage = useCallback((next: number) => setPageState({ id, page: next }), [id]);

    const query = useQuery({
        queryKey: agreementKeys.authorisedContactsPage(id ?? '', page, AUTHORISED_CONTACTS_PER_PAGE),
        queryFn: () => fetchAuthorisedContacts(id!, { page, perPage: AUTHORISED_CONTACTS_PER_PAGE }),
        enabled: !!id,
        placeholderData: (previousData, previousQuery) =>
            previousQuery?.queryKey[2] === (id ?? '') ? previousData : undefined,
    });

    return { query, page, setPage };
}
